import { themeKeys } from './theme';
import { kebabCase } from 'lodash';

export interface Parameter {
  name: string;
  optional: boolean;
  defaultValue?: string;
}

export const CheckoutBackTo = { name: 'checkout-back-to', optional: true };
export const CheckoutPageParameter = { name: 'checkout-page', optional: true };
export const AccountPageParameter = { name: 'account-page', optional: true };
export const LandingPageParameter = { name: 'landing-page', optional: true };
export const InputClassParameter = { name: 'input-class', optional: true };
export const SelectClassParameter = { name: 'select-class', optional: true };
export const ProductIdParameter = { name: 'product-id', optional: true };
export const AutoCheckoutRedirectParameter = { name: 'auto-checkout-redirect', optional: true };
export const BusinessNameParameter = { name: 'business-name', optional: true };
export const TimeoutParameter = { name: 'auto-checkout-redirect-timeout', optional: true, defaultValue: '3000' };
export const CartAddCTAText = { name: 'cart-add-cta-text', optional: true };
export const ProductCTAText = { name: 'product-cta-text', optional: true };
export const EnableModalParameter = { name: 'enable-modal', optional: true };
export const OpenCartWhenProductAddedParameter = {
  name: 'open-cart-when-product-added',
  optional: true,
  defaultValue: 'false',
};

export const packageIdParameter = { name: 'product-package-id', optional: true };

export const ProductIdRequiredParameter = { name: 'product-id', optional: false };
export const AddToCartCTATextParameter = { name: 'add-to-cart-cta-text', optional: true };

export const DirectLinkCodeParameter = { name: 'planne-link-code', optional: false };
export const CustomerAccessTokenParameter = { name: 'customer-access-token', optional: true };
export const OnFinishCheckoutParameter = { name: 'on-finish-checkout', optional: true };
export const FillCustomerFormParameter = { name: 'fill-customer-form', optional: true, defaultValue: 'false' };
export const UseDefaultFont = { name: 'use-default-font', optional: true, defaultValue: 'true' };
export const CurrencyParameter = { name: 'currency', optional: true, defaultValue: 'BRL' };

export const DirectLinkParameters = [
  DirectLinkCodeParameter,
  CustomerAccessTokenParameter,
  OnFinishCheckoutParameter,
  FillCustomerFormParameter,
  UseDefaultFont,
  CurrencyParameter,
];

export const ProductAdderParameters = [
  ProductIdParameter,
  BusinessNameParameter,
  AutoCheckoutRedirectParameter,
  CheckoutPageParameter,
  TimeoutParameter,
  CartAddCTAText,
  ProductCTAText,
  EnableModalParameter,
  OpenCartWhenProductAddedParameter,
  packageIdParameter,
];

export const ProductBookingParameters = [
  ProductIdRequiredParameter,
  AddToCartCTATextParameter,
  EnableModalParameter,
  OpenCartWhenProductAddedParameter,
  AutoCheckoutRedirectParameter,
  CheckoutPageParameter,
  TimeoutParameter,
];

export const ThemeParameters = themeKeys.map((theme) => ({ name: kebabCase(theme), optional: true }));

export const globalParameters = [
  CheckoutBackTo,
  CheckoutPageParameter,
  InputClassParameter,
  SelectClassParameter,
  AccountPageParameter,
  ...ThemeParameters,
] as Parameter[];

export const globalParamsNames = globalParameters.flatMap((w) => w).map((w) => w.name);

export type GlobalParamsNameType = (typeof globalParamsNames)[number];
